<div class="documents-uploader-container">
  <div class="page-header no-margin-left" [ngClass]="{ center: isZoomed }">
    <h2 class="page-title">Your documents</h2>
    <p class="page-text">
      Please upload the required documents to complete the checks. For the
      Current Year Financial Statements, both WORD and PDF formats are accepted.
      All other documents must be in PDF format, with a maximum file size of 30
      MB.
    </p>
  </div>

  <!-- Uploader carousel -->
  <div class="uploaders-container" [ngClass]="{ 'is-zoomed': isZoomed }">
    @for(document of documents; track $index){
    <div class="uploader-elements-container">
      <div
        class="uploader"
        [ngClass]="{
          success: document.succeded,
          error: document.hasError,
          loading: document.retrievalLoading
        }"
        [tabIndex]="0"
        [attr.aria-label]="'Upload ' + document.documentName + ' file'"
        aria-live="polite"
        (click)="uploadWithWarning($index)"
        (keydown.enter)="uploadWithWarning($index)"
      >
        @if(document.file){
        <div class="doc-overlay" (click)="$event.stopPropagation()">
          <motif-dropdown>
            <motif-dropdown-trigger>
              <button
                class="dropdown-toggle-button"
                aria-label="Toggle dropdown button"
                aria-live="polite"
                [tabIndex]="0"
                (keydown.enter)="toggleDocDropdown($event)"
              >
                <motif-icon
                  class="icono-dropdown"
                  size="18"
                  [iconFunction]="IconoirMoreHoriz"
                ></motif-icon>
              </button>
            </motif-dropdown-trigger>

            <motif-dropdown-content class="motif-theme-light">
              <ng-container *ngIf="isValidPdf$ | async as isValidPdf">
                <motif-dropdown-item
                  *ngIf="isValidPdf"
                  class="view-pdf-button"
                  (click)="viewPdf(document.file, $index)"
                  aria-label="View PDF"
                  aria-live="polite"
                >
                  <motif-icon
                    size="18"
                    [iconFunction]="IconoirSearch"
                  ></motif-icon>
                  View PDF
                </motif-dropdown-item>
              </ng-container>

              <motif-dropdown-item
                class="download-document-button"
                (click)="downloadDocument(document.file)"
                aria-label="Download document"
                aria-live="polite"
              >
                <motif-icon
                  size="18"
                  [iconFunction]="IconoirDownload"
                ></motif-icon>
                Download
              </motif-dropdown-item>
            </motif-dropdown-content>
          </motif-dropdown>
        </div>
        }

        <div class="upload-icon-wrapper" [ngClass]="{ success: document.succeded, error: document.hasError }">
          <motif-icon
            *ngIf="!document.retrievalLoading"
            size="24"
            [iconFunction]="IconoirCloudUpload"
            class="upload-icon"
            [ngClass]="{ success: document.succeded, error: document.hasError }"
          ></motif-icon>

          <motif-progress-bar
            *ngIf="document.retrievalLoading"
            [circle]="true"
            [hideLabel]="true"
            [isIndeterminate]="true"
          ></motif-progress-bar>
        </div>

        <!-- Hidden file input -->
        <input
          type="file"
          [tabIndex]="0"
          [id]="'file-input-' + $index"
          #fileInput
          [accept]="document.accept"
          (change)="onFileSelected($event, document, $index)"
          style="display: none"
        />
        <!-- END Hidden file input -->
      </div>

      <div class="uploader-text-container">
        <p class="uploader-text-name">{{ document.documentName }}</p>
        @if(document.file){
        <p class="uploader-text-file-name" [title]="document.file.name">
          {{ document.file.name }}
        </p>
        }
        <p class="uploader-text-date">{{ document.uploadDate }}</p>
      </div>

      @if(document.hasError){
      <div class="uploader-message-container">
        <motif-icon
          size="14"
          class="message-icon error"
          [iconFunction]="IconoirWarningCircle"
        ></motif-icon>
        <p class="upload-message error">{{ document.errorMessage }}</p>
      </div>
      }
    </div>
    }
  </div>
  <!-- Uploader carousel -->
</div>
